import React from "react";
import { AuraHalfHero } from "components/hero";
import { LottieWithStaticSafariImage } from "ui/lottie";
import staticHero from "../../../../../public/assets/solutions/saas/static-hero.png";
import animationData from "./animation.json";

type SaasHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function SaasHero({ eyebrow, title, description }: SaasHeroProps) {
  return (
    <AuraHalfHero
      auraType="square"
      variant="blue"
      eyebrow={eyebrow}
      title={title}
      description={description}
      media={
        <LottieWithStaticSafariImage
          isPriority
          ratio={600 / 420}
          animationData={animationData}
          image={staticHero}
          alt="Abstract illustration of a data warehouse with data for Users, Products, Accounts, and Sales in a column on the left. On the right, there are actions like update account, send onboarding email, create audience, and more being performed in various tools like Salesforce, HubSpot, Slack, LinkedIn, and more."
          containerProps={{
            w: "100%",
            maxW: "680px",
            mx: "auto",
          }}
          staticContainerProps={{
            w: { base: "104%", lg: "112%", xl: "120%" },
            maxW: "680px",
            mx: "auto",
          }}
        />
      }
      mediaWrapperProps={{
        mt: { base: 0, md: "big", lg: 0 },
        pb: { base: 0, md: "huge", lg: 0 },
      }}
    />
  );
}
